import React, { useState, useEffect } from 'react';
// Ikon Material Symbols telah dihapus total.

// Ganti PLACHOLDER_APPS_SCRIPT_URL_ANDA dengan URL Web App Apps Script Anda yang sudah di-deploy.
const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzJdbpYKc8vYfPKRAIUtkB4mqXavM5M1TfZS6zDagWUGlbGDybY4RkrwwSG2N8Kjezx/exec'; 

// URL Logo yang diminta pengguna
const LOGO_URL = 'https://res.cloudinary.com/db5e5ob2w/image/upload/v1764682664/bos5000/logo_small_1.png';
// URL Gambar baru yang diminta pengguna
const SEARCH_IMAGE_URL = 'https://res.cloudinary.com/db5e5ob2w/image/upload/v1764682992/bos5000/images/bos5000-google.png';

// URL Google Search yang diminta
const GOOGLE_SEARCH_URL = 'https://www.google.com/search?q=BOS5000';

// Implementasi fungsi untuk melakukan penundaan (delay) dan mencoba ulang (retry)
const fetchWithRetry = async (url, options, retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      const response = await fetch(url, options);
      if (response.ok) {
        return response;
      }
      // Jika respons tidak OK, coba lagi (kecuali ini percobaan terakhir)
      if (i < retries - 1) {
        console.warn(`Percobaan gagal (${i + 1}/${retries}). Mencoba lagi dalam 2 detik...`);
        // Exponential backoff: 2s, 4s, 8s (approx)
        await new Promise(resolve => setTimeout(resolve, 2000 * Math.pow(2, i)));
      } else {
        throw new Error(`Permintaan gagal setelah ${retries} percobaan.`);
      }
    } catch (error) {
      if (i < retries - 1) {
        console.error(`Error pada percobaan ${i + 1}:`, error.message);
        await new Promise(resolve => setTimeout(resolve, 2000 * Math.pow(2, i)));
      } else {
        throw error;
      }
    }
  }
};


const InputField = ({ id, label, type = 'text', value, onChange, placeholder, required = true, note }) => (
  <div className="relative mb-4">
    {/* Label: Menggunakan warna Emas/Kuning agar terlihat jelas pada latar belakang formulir marun gelap */}
    <label htmlFor={id} className="text-yellow-400 block mb-1 font-semibold text-sm">
      {label}*
    </label>
    <div className="relative">
      {/* Ikon Dihilangkan */}
      <input
        id={id}
        name={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        // Input Field: background putih (bg-white), teks gelap (text-gray-900), sesuai permintaan
        className="w-full pl-4 pr-4 py-3 bg-white border-2 border-red-700 text-gray-900 rounded-lg shadow-xl focus:border-red-500 focus:ring-1 focus:ring-red-500 transition duration-150 text-sm"
      />
      {note && (
        <p className="text-xs text-red-400 mt-1 pl-1">{note}</p>
      )}
    </div>
  </div>
);

// Fungsi untuk memicu Tawk.to chat
const openLiveChat = () => {
    // Tawk_API adalah global object yang disediakan oleh script Tawk.to
    if (window.Tawk_API) {
        window.Tawk_API.maximize();
    } else {
        // Menggunakan console.error karena alert() dilarang dalam konteks ini
        console.error("Tawk.to API belum dimuat. Harap tunggu sebentar atau klik tombol livechat di pojok bawah.");
    }
};

// Komponen tampilan sukses/countdown
const SuccessView = ({ countdown, finalMessage }) => {
    const minutes = Math.floor(countdown / 60);
    const seconds = countdown % 60;
    const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    
    // Pesan yang diminta pengguna
    const livechatMessage = "ID Anda akan diinformasikan melalui livechat. silahkan klik tombol berikut untuk buka livechat.";
    const secondaryMessage = "JIKA MENGALAMI KENDALA SILAHKAN HUBUNGI KAMI PADA LIVECHAT";

    return (
        // Menggunakan space-y-4 untuk jarak yang lebih teratur
        <div className="text-center p-4 space-y-4 text-white">
            
            {/* Countdown (Gaya disesuaikan dengan tema) */}
            <div className="flex items-center justify-center space-x-2 text-xl font-bold text-yellow-400 bg-red-900 p-2 rounded-lg border border-red-700 shadow-md">
                {/* Ikon Teks: Timer */}
                <span className="text-xl text-yellow-400">🕒</span>
                <span>Sisa Waktu Proses: {formattedTime}</span>
            </div>
            
            {/* Pesan ID Livechat */}
            <div className="bg-red-700 border-2 border-yellow-500 text-white p-4 rounded-lg shadow-xl">
                <p className="font-semibold text-base">{livechatMessage}</p>
            </div>

            {/* Tombol Buka Livechat (Sekarang dengan Gradient) */}
            <button
                onClick={openLiveChat}
                style={{ backgroundImage: 'linear-gradient(to bottom, #ffff58 0%, #b56000 100%)' }}
                className="inline-flex items-center justify-center w-full px-4 py-3 border border-transparent text-sm font-bold rounded-lg shadow-xl text-black transition duration-150 transform hover:scale-[1.02] hover:opacity-90 focus:outline-none focus:ring-4 focus:ring-yellow-500 focus:ring-opacity-50"
            >
                {/* Ikon Teks: Chat */}
                <span className="text-xl mr-2">💬</span>
                Buka Livechat Sekarang
            </button>
            
            {countdown === 0 && (
                <div className="text-yellow-400 font-bold text-base p-3 border-2 border-yellow-500 rounded-lg bg-red-900 shadow-lg">
                    {finalMessage}
                </div>
            )}
            
            {/* Pesan Livechat sekunder, untuk kendala (Sekarang dengan Gradient) */}
            <div 
                className="text-black font-extrabold p-3 rounded-lg shadow-lg text-sm border-2 border-yellow-700"
                style={{ backgroundImage: 'linear-gradient(to bottom, #ffff58 0%, #b56000 100%)' }}
            >
                {secondaryMessage}
            </div>

            <a
                href={GOOGLE_SEARCH_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-full px-4 py-3 border-2 border-red-700 text-sm font-medium rounded-lg shadow-md text-red-700 bg-white hover:bg-gray-100 transition duration-150"
            >
                Cari kami di Google
            </a>

            {/* Gambar yang sudah ada */}
            <img 
                src={SEARCH_IMAGE_URL} 
                alt="BOS5000 Google Search" 
                className="mx-auto w-full max-w-xs h-auto rounded-lg shadow-md mt-4 border-2 border-red-700" 
                onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/300x100/34D399/ffffff?text=Image+Placeholder" }} // Fallback image
            />
            
            <p className="text-xs text-gray-300 mt-4">Proses ini memakan waktu maksimal 1 menit. Silahkan hubungi Livechat setelah selesai.</p>
        </div>
    );
};

const App = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    bankEwallet: '',
    namaRek: '',
    noRek: '',
    noHp: '',
    email: '',
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [countdown, setCountdown] = useState(0); // Countdown dalam detik

  // Logika Countdown
  useEffect(() => {
    if (isSuccess && countdown > 0) {
        const timer = setInterval(() => {
            setCountdown(prev => prev - 1);
        }, 1000);
        return () => clearInterval(timer);
    } else if (countdown === 0 && isSuccess) {
        setMessage('ID berhasil dibuat. Silakan hubungi layanan pelanggan (Livechat) untuk ID VIP Anda.');
    }
  }, [countdown, isSuccess]);

  // Efek untuk memuat Tawk.to Live Chat Script.
  useEffect(() => {
    // Tawk.to Script Start
    if (typeof window.Tawk_API === 'undefined') {
        var Tawk_API = Tawk_API || {};
        var Tawk_LoadStart = new Date();
        window.Tawk_API = Tawk_API; // Set global Tawk_API

        (function () {
          var s1 = document.createElement("script"),
            s0 = document.getElementsByTagName("script")[0];
          s1.async = true;
          s1.src = 'https://embed.tawk.to/692fdf6b74bc82197112ffa1/1jbhg1fm0';
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin','*');
          s0.parentNode.insertBefore(s1, s0);
        })();
    }
  }, []); 


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (SCRIPT_URL.includes('PLACHOLDER')) {
        setMessage('Gagal: Harap ganti PLACHOLDER_APPS_SCRIPT_URL_ANDA dengan URL Web App Anda.');
        setIsSuccess(false);
        return;
    }

    setLoading(true);
    setMessage('');
    setIsSuccess(false);

    const urlEncodedData = new URLSearchParams();
    for (const key in formData) {
      urlEncodedData.append(key, formData[key]);
    }

    try {
        const response = await fetchWithRetry(SCRIPT_URL, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: urlEncodedData.toString(),
        });

        if (response.ok) {
            const result = await response.json();
            
            if (result.status === 'success') {
                // Logika SUKSES
                setMessage('Data berhasil dikirim. Silakan buka Livechat.');
                setIsSuccess(true);
                setCountdown(60); // Mulai countdown 60 detik (1 menit)
            } else if (result.status === 'duplicate') {
                // Logika DUPLIKAT (status baru dari Apps Script)
                setMessage('Data sudah ada. silahkan buat dengan data yang berbeda.');
                setIsSuccess(false);
            } else {
                setMessage(`Gagal mengirim data: ${result.message || 'Respons tidak terduga dari server.'}`);
                setIsSuccess(false);
            }
        } else {
            setMessage(`Gagal mengirim data. Status HTTP: ${response.status} ${response.statusText}`);
            setIsSuccess(false);
        }

    } catch (error) {
        setMessage(`Error jaringan atau server: ${error.message}`);
        setIsSuccess(false);
    } finally {
        setLoading(false);
    }
  };

  return (
    // Latar belakang Merah Tua dengan kode warna #5c0000
    <div className="min-h-screen bg-[#5c0000] flex items-center justify-center p-4">
      {/* Menggunakan max-w-md agar form proporsional di desktop, tetapi full-width di mobile */}
      <div className="w-full max-w-md">
        {/* Logo di atas card */}
        <img 
            src={LOGO_URL} 
            alt="Logo BOS5000" 
            onError={(e) => { e.target.onerror = null; e.target.src = "https://placehold.co/100x40/5c5c5c/ffffff?text=LOGO" }} // Fallback image
            className="mx-auto h-20 object-contain mb-4" 
        />

        {/* Card utama: Latar belakang MAROON GELAP (#4d0000), Border Emas */}
        <div className="bg-[#4d0000] p-6 rounded-xl shadow-2xl border-2 border-yellow-500">
          
          <h1 className="text-xl font-bold text-center text-yellow-400 mb-4 flex items-center justify-center border-b border-yellow-600 pb-2">
            {/* Ikon Teks: Person */}
            <span className="text-2xl mr-2">⚡</span> 
            Formulir Pendaftaran
          </h1>
          
          {/* Catatan (Latar belakang yang sedikit lebih gelap agar kontras) */}
          <div className="bg-red-950 p-3 rounded-lg mb-6 border-l-4 border-yellow-500">
            <h2 className="text-yellow-400 font-bold mb-1 text-sm">Catatan :</h2>
            <ul className="text-gray-300 text-xs list-disc pl-5 space-y-0.5">
              <li>Nama pengguna harus terdiri dari 6 hingga 15 karakter dan menggunakan alfabat.</li>
              <li>Kata sandi harus terdiri dari 8 hingga 25 karakter.</li>
            </ul>
          </div>

          {/* Conditional Rendering: Tampilkan SuccessView atau Form */}
          {isSuccess ? (
            <SuccessView countdown={countdown} finalMessage={message} />
          ) : (
            <>
              <form onSubmit={handleSubmit} className="space-y-4">
                
                <InputField 
                  id="username" 
                  label="Nama Pengguna" 
                  value={formData.username} 
                  onChange={handleChange} 
                  placeholder="nama pengguna"
                  note="Nama pengguna minimal 6 karakter, mengandung alfabet."
                />
                
                {/* Kata Sandi */}
                <InputField 
                  id="password" 
                  label="Kata Sandi" 
                  type="password"
                  value={formData.password} 
                  onChange={handleChange} 
                  placeholder="Kata Sandi"
                  note="Kata sandi harus minimal 8 karakter, mengandung setidaknya huruf dan angka. cth: password123"
                />
                <InputField 
                  id="bankEwallet" 
                  label="Bank/E-wallet" 
                  value={formData.bankEwallet} 
                  onChange={handleChange} 
                  placeholder="Contoh: BCA, Dana, OVO"
                />
                <InputField 
                  id="namaRek" 
                  label="Nama Rekening/Akun" 
                  value={formData.namaRek} 
                  onChange={handleChange} 
                  placeholder="Sesuai nama di Bank/E-wallet"
                />
                <InputField 
                  id="noRek" 
                  label="Nomor Rekening/Akun" 
                  value={formData.noRek} 
                  onChange={handleChange} 
                  placeholder="Masukkan nomor rekening/akun"
                />
                <InputField 
                  id="noHp" 
                  label="Nomor HP" 
                  value={formData.noHp} 
                  onChange={handleChange} 
                  placeholder="Contoh: 08123456789"
                />
                <InputField 
                  id="email" 
                  label="Email" 
                  type="email"
                  value={formData.email} 
                  onChange={handleChange} 
                  placeholder="Contoh: nama@domain.com"
                />
                
                <button
                  type="submit"
                  disabled={loading}
                  // Menerapkan Gradient yang diminta pada tombol Kirim Pendaftaran
                  style={{ backgroundImage: 'linear-gradient(to bottom, #ffff58 0%, #b56000 100%)' }}
                  className={`w-full py-3 mt-6 text-black font-extrabold rounded-lg shadow-xl transition duration-200 
                    ${loading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90 focus:outline-none focus:ring-4 focus:ring-yellow-500 focus:ring-opacity-50'}`}
                >
                  {loading ? 'Mengirim Data...' : 'Kirim Pendaftaran'}
                </button>
              </form>

              {message && (
                <div className={`mt-4 p-3 rounded-lg text-sm font-medium ${!isSuccess ? 'bg-red-700 text-yellow-400' : 'bg-green-700 text-white'}`} role="alert">
                  {message}
                </div>
              )}
            </>
          )}

        </div>
      </div>
    </div>
  );
};

export default App;